<template>
    <div>
        <!-- <Basicform
        ref="basicform"
          :title="formTitle"
          :module-code="moduleInfo.moduleCode"
          :win-width="moduleInfo.winWidth"
          :win-height="moduleInfo.winHeight"
          :toolbar-btns="busiformBtns"
          :on-basic-form-before-open="onBasicFormBeforeOpen"
          :on-basic-form-opened="onBasicFormOpened"
          :on-basic-form-before-submit="onBasicFormBeforeSubmit"
          :on-basic-form-submited="onBasicFormSubmited"
        >
          <template v-slot:default="slotProps">
            <busi-form ref="busiform" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
          </template>
        </Basicform> -->

        <busi-form ref="busiform" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" />
    </div>

 </template>

<script>
export default {
    props: {
        vo: { type: Object, default: function() { return {} } },
        canEdit: { type: Number, default: 0 }
    },
    data() {
        return {
            showView: 'mainform',
       	loginUser: this.$store.getters.loginUser,
            moduleInfo: {'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/student/basicInfo/form.html', 'addNewUrl': 'xsgl/studentBasicInfo/addNew', 'insertUrl': 'xsgl/studentBasicInfo/insert', 'getByIdUrl': 'xsgl/studentBasicInfo/getById', 'updateUrl': 'xsgl/studentBasicInfo/update', 'delUrl': 'xsgl/studentBasicInfo/delete', 'listDataUrl': 'xsgl/studentBasicInfo/listdata', 'winWidth': 1200, 'winHeight': 600, 'moduleCode': 'basicInfo', 'openViewType': '0', 'listAdvSearchAllFields': 0, 'listAdvSearchExpandPanel': 0, 'oldListDataUrl': '/xsgl/studentBasicInfo/listdata', 'busiFormTemplate': '/student/basicInfo/form'},
            busiformBtns: [],
            formTitle: '学生档案'
        }
    },
    created: function() {
        this.$bus.on('refreshListData', this.refreshTreeData)
        let formurl = this.moduleInfo.formTemplate.split('url=')[1]
        formurl = formurl.replace(/\//g, '.')
        formurl = '#/dcontent/vuebusiform/W/' + formurl.substring(1).replace('.html', '.vue')
        formurl += '?sysCode=' + (this.$route.meta.sysCode || '')
        this.$options.components['BusiForm'] = this.$loadComponent(formurl)
    },
    beforeDestroy: function() {
        this.$bus.off('refreshListData', this.refreshTreeData)
    },
    methods: {
        /**
             * 表单打开检查，vo为已加载archiveInfo对象，允许打开：defer.resolve(true)，阻止打开：defer.reject(reason)
             */
        onBasicFormBeforeOpen: function($scope, vo, defer) {
            if (process.env.NODE_ENV === 'development') console.log('archiveInfo form before open')
           			defer.resolve(true)
        },
        /**
              * 表单打开完成，vo为已加载的archiveInfo对象，前端页面dom对象已完成初始化、已经呈现，不需要返回值
             */
        onBasicFormOpened: function($scope, vo) {
            if (process.env.NODE_ENV === 'development') console.log('archiveInfo form opened')
        },
        /**
              * 表单提交事件，可执行业务数据高级校验，vo为待提交的archiveInfo对象，校验成功：defer.resolve(true)，校验失败：defer.reject(reason)
              */
        onBasicFormBeforeSubmit: function($scope, vo, defer) {
            /*this.$confirm('您是否确认提交保存?', '确认操作', {
                     confirmButtonText: '确定',
                     cancelButtonText: '取消',
                     type: 'warning'
                 })
                     .then(() => {
                         defer.resolve(true)
                     })
                     .catch(err => {
                         defer.reject(err)
                     })*/

            if (process.env.NODE_ENV === 'development') console.log('archiveInfo form submit validation success')
           			defer.resolve(true)
        },
        /**
             * 表单提交完成，vo为已保存成功的archiveInfo对象，窗口即将关闭，不需要返回值
             */
        onBasicFormSubmited: function($scope, vo) {
            if (process.env.NODE_ENV === 'development') console.log('archiveInfo form submited')
        }
    }
}
</script>

<style scoped>
.header {
    padding:10px 20px;
    background-color: #f2f5fb;
    font-size: 15px;
    border-top:1px solid #999;
    border-left:1px solid #999;
    border-right:1px solid #999;
}
.box {
   border:1px solid #999;
}
</style>
